<template>
  <div v-loading="isLoading">
    <div v-for="(item, index) in dataIn.serviceList" :key="index">
      <serviceDetail :isReadonly="isReadonly" :dataIn="item" :contractList="contractList"></serviceDetail>
    </div>
  </div>
</template>

<style lang="scss" scoped>
</style>

<script>
import serviceDetail from "./serviceDetail";

export default {
  props: {
    isReadonly: Boolean,
    contractList: {
      type: Array,
      default: () => [],
    },
    dataIn: {
      serviceList: Array,
    },
  },
  data() {
    return {
      isLoading: false,
    };
  },
  components: {
    serviceDetail,
  },
  computed: {},
  created() {},
  methods: {
    init() {},
  },
  watch: {},
};
</script>



// WEBPACK FOOTER //
// src/components/studyAbroad/workflow/serviceList.vue